import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import MuiCssBaseline from './MuiCssBaseline';
import palette from './palette';
import MuiAppBar from './MuiAppBar';

const theme = createTheme({
  palette,
  components: {
    MuiCssBaseline,
    MuiAppBar
  }
});

console.log(theme);

export default responsiveFontSizes(theme);
